export const FEATURE_FLAGS = {
  ANNUAL_APPRAISALS_ENABLED: false,
  JOB_DESCRIPTIONS_ENABLED: true,
  /** Profile tab shows the issued copy, or the approved template for the employee's position. */
  JOB_DESCRIPTIONS_IN_PROFILES_ENABLED: true
};

export const isAnnualAppraisalsEnabled = () => FEATURE_FLAGS.ANNUAL_APPRAISALS_ENABLED;

export const isJobDescriptionsEnabled = () => FEATURE_FLAGS.JOB_DESCRIPTIONS_ENABLED;

export const isJobDescriptionsInProfilesEnabled = () =>
  FEATURE_FLAGS.JOB_DESCRIPTIONS_ENABLED && FEATURE_FLAGS.JOB_DESCRIPTIONS_IN_PROFILES_ENABLED;

/** Drop inbox rows for modules hidden by feature flags. */
export const filterInboxItemsWithoutDisabledFeatures = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  if (isAnnualAppraisalsEnabled()) {
    return list;
  }
  return list.filter((row) => String(row?.object_type || '') !== 'annual_appraisal');
};
